import React from "react";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";

import "./style.css";

const predefinedRanges = [
  {
    label: "This week",
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement: "left",
    closeOverlay: false,
  },
  {
    label: "Last 7 days",
    value: [subDays(new Date(), 6), new Date()],
    placement: "left",
    closeOverlay: false,
  },
  {
    label: "This month",
    value: [startOfMonth(new Date()), new Date()],
    placement: "left",
    closeOverlay: false,
  },

  {
    label: "Last month",
    closeOverlay: false,
    value: [
      startOfMonth(addMonths(new Date(), -1)),
      endOfMonth(addMonths(new Date(), -1)),
    ],
    placement: "left",
  },
  {
    label: "This year",
    closeOverlay: false,
    value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
    placement: "left",
  },
];
const CustomDateRangePicker = (props) => {
  let {
    handelDateChange,
    startDate,
    endDate,
    defaultStartDate,
    defaultEndDate,
    className,
  } = props;

  // console.log(startDate, "=== default");
  // console.log(endDate, "===end date");
  // console.log(defaultStartDate, "===start default");
  // console.log(defaultEndDate, "===end default");

  return (
    <div className="flex flex-row justify-end items-center mx-auto">
      <DateRangePicker
        appearance="subtle"
        placement="bottomEnd"
        preventOverflow
        ranges={[
          ...predefinedRanges,
          {
            label: "All Time",
            closeOverlay: false,
            placement: "left",
            value: [new Date(defaultStartDate), new Date(defaultEndDate)],
          },
        ]}
        placeholder={`${startDate} to ${endDate}`}
        value={[new Date(startDate), new Date(endDate)]}
        onOk={handelDateChange}
        cleanable={false}
        className={className ? className : "w-max mb-12"}
      />
    </div>
  );
};

export default CustomDateRangePicker;
